import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateSendMessageChat = {
  sendMessageChat: { data: null, loading: false, error: null },
};

export const sendMessageChat = createAsyncThunk('tariff/sendMessageChat', async (data, { rejectWithValue, fulfillWithValue }) => {
  const token = localStorage?.getItem('token');
  if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
  return await axios
    .post(`${process.env.REACT_APP_SERVER_API}/ai-chat/${data.conversation_id}/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        // Accept: '*/*',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        // Connection: 'keep-alive',
      },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSendMessageChat = {
  [sendMessageChat.pending]: (state) => {
    state.sendMessageChat.loading = true;
  },
  [sendMessageChat.fulfilled]: (state, action) => {
    state.sendMessageChat.loading = false;
    state.sendMessageChat.data = action.payload;
    state.sendMessageChat.error = null;
  },
  [sendMessageChat.rejected]: (state, action) => {
    state.sendMessageChat.loading = false;
    state.sendMessageChat.data = action?.payload;
    state.sendMessageChat.error = true;
  },
};
